import { render, staticRenderFns } from "./LogFriendRequest.vue?vue&type=template&id=464966c1&scoped=true"
import script from "./LogFriendRequest.vue?vue&type=script&lang=js"
export * from "./LogFriendRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464966c1",
  null
  
)

export default component.exports